module.exports = __webpack_public_path__ + "assets/icon_s2p_highlight.27a142b6.svg";